// Fall back to the API origin (REACT_APP_API_URL minus the trailing /api/) when REACT_APP_BACK_URL is not set.
const BackUrl = process.env.REACT_APP_BACK_URL || (process.env.REACT_APP_API_URL || '').replace(/\/api\/?$/, '');
export const ImageBaseUrl = BackUrl + '/uploads/image/';
